import { ChangeEvent } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { updateFilter, radiusSelector } from '@zoopla/redux-reducer-filters';
import { SelectRadiusOptions } from '../../../search/common/SelectRadiusOptions';
import { DropdownWithLabel } from '@blueprint/dropdown';

export const SelectRadius = () => {
    const reduxDispatch = useDispatch();
    const { selectedValue, options } = useSelector(radiusSelector);

    const onRadiusChange = (evt: ChangeEvent<HTMLSelectElement>) => {
        reduxDispatch(updateFilter('radius', evt.currentTarget.value));
    };
    const radiusLabel = 'Search radius';

    return (
        <DropdownWithLabel
            id="desktop_radius-filter"
            data-testid="desktop_radius-filter"
            onChange={onRadiusChange}
            value={selectedValue}
            name="radius"
            aria-label="Radius"
            label={radiusLabel}
            hasExtendedHeight
            hasDarkPurpleBorder
            hasNoLeftRightBorder
        >
            {options.length ? (
                <SelectRadiusOptions
                    keyPrefix="quicksearch"
                    options={options}
                />
            ) : null}
        </DropdownWithLabel>
    );
};
